import Vue from 'vue'
import Vuex from 'vuex'
import templatesModule from './modules/templates'
import playersModule from './modules/players'
import authModule from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    templates: templatesModule,
    players: playersModule,
    auth: authModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js